import React, { useState } from 'react';

import {
  CancellationPolicyLink,
  CancellingInfo,
  CancellingInfoTitle
} from './CancellationInfo.styled';
import { CancellationPolicyModal } from 'screens/Book/components/CancellationPolicyModal';

const CANCELLATION_POLICY_TEXT =
  'If you are unable to make your appointment, be sure to cancel within the designated timeframe as stipulated in our';
const CANCELLATION_POLICY_LINK = 'cancellation policy';

export const CancellationInfo = () => {
  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);
  return (
    <CancellingInfo>
      <CancellingInfoTitle>Need to cancel?</CancellingInfoTitle>
      {CANCELLATION_POLICY_TEXT}{' '}
      <CancellationPolicyLink
        onClick={() => setShowCancellationPolicy(true)}
        text={CANCELLATION_POLICY_LINK}
      />
      <CancellationPolicyModal
        show={showCancellationPolicy}
        onClickClose={() => setShowCancellationPolicy(false)}
      />
    </CancellingInfo>
  );
};
